// Working-day arithmetic for defer / scheduled-date defaults.
//
// Per Kalpana (UAT round 3): Saturday is a working day; only Sunday is
// non-working. So this skips day-of-week 0 (Sunday) when counting forward.
// If we ever need to honour holidays, swap this for a list-driven check.

const SUNDAY = 0;

/**
 * Add `n` working days to `start`. Returns a new Date.
 * Day-of-week: 0=Sun, 1=Mon, …, 6=Sat. Sundays are skipped.
 */
export function addWorkingDays(start, n) {
  const d = start instanceof Date ? new Date(start) : new Date(start);
  let added = 0;
  while (added < n) {
    d.setDate(d.getDate() + 1);
    if (d.getDay() !== SUNDAY) added += 1;
  }
  return d;
}

/** YYYY-MM-DD for `today + n working days` (local time). */
export function addWorkingDaysISO(n, fromDate = new Date()) {
  const d = addWorkingDays(fromDate, n);
  // toISOString shifts to UTC and can roll the date back. Build the string
  // from the local fields directly so the user sees the date they expect.
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

/**
 * How many working days between `from` and `to`, inclusive of neither
 * endpoint. Used for the Scheduled Splits "Defer Days" column.
 * Returns 0 if to <= from.
 */
export function workingDaysBetween(from, to) {
  const a = new Date(from);
  const b = new Date(to);
  if (b <= a) return 0;
  let count = 0;
  const cursor = new Date(a);
  while (cursor < b) {
    cursor.setDate(cursor.getDate() + 1);
    if (cursor.getDay() !== SUNDAY) count += 1;
  }
  return count;
}
